<template>
  <div>
    <div v-if="isRouterAlive">
      <Slider :banner="$t('sliderimg')">
        <div class="row align-items-center">
          <div class="col fontsiyuanmedium">
            <div class="slider-news-title fontsiyuanmedium">
              {{ $t("slidertitle") }}
            </div>
            <div class="slider-news-subtitle fontsiyuanregular">
              {{ $t("slidersubtitle") }}
            </div>
          </div>
        </div>
      </Slider>
      <div>
        <!-- 标题栏 -->
        <div class="news-title-wide news-title-group sticky2">
          <b-container>
            <div class="row justify-content-center">
              <div
                :class="`col-md-2 col-sm-3 news-title ${
                  active == 0 ? 'active' : ''
                }`"
                @click="change(0)"
              >
                <span> {{ $t("titlet1") }}</span>
              </div>
              <div
                :class="`col-md-2 col-sm-3 news-title ${
                  active == 1 ? 'active' : ''
                }`"
                @click="change(1)"
              >
                <span> {{ $t("titlet2") }}</span>
              </div>
              <div
                :class="`col-md-2 col-sm-3 news-title ${
                  active == 2 ? 'active' : ''
                }`"
                @click="change(2)"
              >
                <span> {{ $t("titlet3") }}</span>
              </div>
              <div
                :class="`col-md-2 col-sm-3 news-title ${
                  active == 3 ? 'active' : ''
                }`"
                @click="change(3)"
              >
                <span> {{ $t("titlet4") }}</span>
              </div>
            </div>
          </b-container>
        </div>

        <div class="news-title-thin">
          <b-container>
            <div class="news-title-header" @click="visible1 = !visible1">
              <span class="news-title-title"> {{ $t("titlet"+(active+1)) }}</span>
              <span class="news-title-button"
                ><b-img v-if="!visible1" :src="colarrowdown"></b-img
                ><b-img v-if="visible1" :src="colarrowup"></b-img
              ></span>
            </div>
            <b-collapse
              v-model="visible1"
              class="thin-item-body"
              style="z-index: 1703"
            > 
            <div class="news-title-header" v-if="active!=0"
                @click="change(0)">
                <span class="news-title-title" >{{ $t("titlet1") }}</span>
              </div>
            <div class="news-title-header" v-if="active!=1"
                @click="change(1)">
                <span class="news-title-title">{{ $t("titlet2") }}</span>
              </div>
            <div class="news-title-header" v-if="active!=2"
                @click="change(2)">
                <span class="news-title-title">{{ $t("titlet3") }}</span>
              </div>
            <div class="news-title-header" v-if="active!=3"
                @click="change(3)">
                <span class="news-title-title">{{ $t("titlet4") }}</span>
              </div>
            </b-collapse>
          </b-container>
        </div>
      </div>
    </div>
    <div>
      <Newsl1 v-if="active == 0" :active="active" />
      <Newsl2 v-if="active == 1" :active="active" />
      <Newsl3 v-if="active == 2" :active="active" />
      <Newsl4 v-if="active == 3" :active="active" />
    </div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider2";
import Footer from "../components/footer";
import Sticky from "sticky-js";
import Newsl1 from "./newsl1.vue";
import Newsl2 from "./newsl2.vue";
import Newsl3 from "./newsl3.vue";
import Newsl4 from "./newsl4.vue";
export default {
  components: {
    Slider,
    Footer,
    Newsl1,
    Newsl2,
    Newsl3,
    Newsl4,
  },
  data() {
    return {
      isRouterAlive: true,
      active: 0,

      limit: 12,
      page: 1,
      type: 0,

      newslist: [],

      rows: 0,

      visible1: false,

      newslistname: "",
    };
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.sort != from.query.sort) {
        this.active = parseInt(to.query.sort);
        this.$i18n.locale = localStorage.getItem("lang") || "zh";
      }
    },
  },
  computed: {
    colarrowdown() {
      return this.$store.state.colarrowdown;
    },
    colarrowup() {
      return this.$store.state.colarrowup;
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getNews() {
      const _this = this;
      this.$store.dispatch("getNews").then(({ zh, en }) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

        let lang = _this.$i18n.locale;
        _this.$i18n.locale = lang;
        _this.reload();
        const sticky2 = new Sticky(".sticky2");
        sticky2.update();
      });
    },
    change(index) {
      this.$router.push({
        path: `/news?sort=${index}`,
      });
      this.visible1=false
    },
  },
  created() {},
  mounted() {
    this.active = parseInt(this.$route.query.sort);
    this.getNews();
  },
};
</script>
<style>
.slider-news-title {
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
  font-weight: bold;
}
.slider-news-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 20px;
  font-weight: 100;
}
.news-title-group {
  text-align: center;
  z-index: 1702;
  background-color: #fff;
  border-bottom: 0.5px #bdbdbd88 solid;
  height:75px;
}
.news-title {
  padding: 25px 0;
  cursor: pointer;
}
.news-title span {
  padding: 28px 0;
}
.news-title span:hover {
  color: #c00f31;
  font-weight: 800;
  border-bottom: 3px solid #c00f31;
}
.news-title.active span {
  border-bottom: 3px solid #c00f31;
}
.news-title.active {
  color: #c00f31;
  font-weight: 800;
}
.news-list {
  padding-bottom: 100px;
}
.page-item.active .page-link {
  color: #c00f31;
  background-color: #ffffff00;
}
.page-link {
  color: #000;
  border: 0;
}
.page-link:hover {
  color: #c00f31;
}
.pagestyle {
  color: #000;
  padding: 6px 10px;
  border: 0.5px #bdbdbd88 solid;
}
.pagestyle:hover {
  background-color: #00000000;
  color: #c00f31;
}
.news-pagination button:hover {
  background-color: #00000000;
}
.page-item:hover {
  background-color: #00000000;
}
.news-pagination {
  margin-top: 100px;
}
.news-item {
  margin-top: 30px;
  cursor: pointer;
}

.news-item:hover {
  -webkit-box-shadow: #00000034 0px 0px 10px;
  -moz-box-shadow: #00000034 0px 0px 10px;
  box-shadow: #00000034 0px 0px 10px;
}
.news-body {
  padding: 10px 30px 20px 30px;
  background-color: #ededed;
}
.product-item-body-head {
  font-size: 12px;
}
.product-item-date {
  font-size: 12px;
  font-weight: 200;
  color: #8a8a8a;
  margin-left: 10px;
}
.product-item-type {
  background-color: #c00f31;
  color: #ffffff;
  padding: 0 5px;
  margin-left: 15px;
}
.news-item-title {
  /* white-space: nowrap; */
  font-weight: bold;
  font-size: 16px;
  color: #000;
       overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
}
.news-item-info {
  margin-top: 30px;
  font-size: 12px;
  height: 50px;
  color: #8a8a8a;overflow:hidden;

text-overflow:ellipsis;

display:-webkit-box;

-webkit-line-clamp:2;

-webkit-box-orient:vertical;
}

.news-title-thin {
  display: none;
}
@media only screen and (max-width: 1000px) {
  .news-title-wide {
    display: none;
  }
  .news-title-thin {
    display: block;
  }
  .news-title-button img {
    width: 15px;
    position: absolute;
    right: 30px;
  }
  .news-title-header {
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0;
    border-bottom: 1px #bdbdbd44 solid;
  }
}
</style>
